/**
 * MS-533 — the approved agreement body arrives as plain text with "## " marking headings.
 *
 * Rendering it line by line (rather than as HTML) keeps the legal text un-interpretable as
 * markup. The document is server-controlled, but treating it as data is what makes that safe
 * to rely on. Ported from msool-frontend's RentalAgreementModal so both surfaces parse
 * identically.
 */
const HEADING_PREFIX = "## ";

export interface AgreementLine {
  key: string;
  text: string;
  isHeading: boolean;
}

export function parseAgreementBody(body: string): AgreementLine[] {
  return body
    .split("\n")
    .map((line, index) => {
      const trimmed = line.trim();
      const isHeading = trimmed.startsWith(HEADING_PREFIX);
      return {
        key: `${index}`,
        text: isHeading ? trimmed.slice(HEADING_PREFIX.length).trim() : trimmed,
        isHeading,
      };
    })
    .filter((line) => line.text.length > 0);
}
